namespace Matrix.Data {
    export interface AccountModelTargetIsPendingApprovalRequest extends Serenity.ServiceRequest {
        ModelCode?: string;
        AccountCode?: string;
        Details?: boolean;
    }
}
